import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import MomentAtmosphere from './MomentAtmosphere';

const MOMENTS = {
  family: {
    source: require('@/assets/images/landing-life-family.png'),
    label: 'A dad plays catch with his children while a robot works at a laptop on the porch.',
  },
  picnic: {
    source: require('@/assets/images/landing-life-picnic.png'),
    label: 'A family enjoys a mountain picnic while their robot works at a nearby table.',
  },
  garden: {
    source: require('@/assets/images/landing-life-garden.png'),
    label: 'A dad and his children tend their garden while a robot handles work at a potting bench.',
  },
};

/** Uncropped scenic interludes keep both the family and robot visible on phones. */
export default function LivingMoment({ scene }) {
  const moment = MOMENTS[scene];
  return (
    <View nativeID={`landing-life-${scene}`} style={{ width: '100%', aspectRatio: 1916 / 821, position: 'relative', overflow: 'hidden', backgroundColor: '#40644A' }}>
      <Image source={moment.source} accessibilityLabel={moment.label} contentFit="contain" style={StyleSheet.absoluteFillObject} />
      <MomentAtmosphere scene={scene} />
    </View>
  );
}
